export default "__VITE_ASSET__DPScZAJP__"